var _rect, _rect2, _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 22.0459,
    height: 22.0459,
    rx: 2.18918,
    fill: "#FF3296"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6.5,
    y: 4.25,
    width: 9,
    height: 13.5,
    rx: 1.5,
    fill: "#383538",
    stroke: "white",
    strokeWidth: 0.9
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 4.25V4.25C8.75 4.59874 8.75 4.77311 8.78833 4.91617C8.89236 5.3044 9.1956 5.60764 9.58383 5.71167C9.72689 5.75 9.90126 5.75 10.25 5.75H11.75C12.0987 5.75 12.2731 5.75 12.4162 5.71167C12.8044 5.60764 13.1076 5.3044 13.2117 4.91617C13.25 4.77311 13.25 4.59874 13.25 4.25V4.25",
    stroke: "white",
    strokeWidth: 0.9
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 15.5,
    r: 0.75,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.fbf4acb6bd1bb3aaf3388e0ec8941903.svg";
export { ForwardRef as ReactComponent };